import { render, staticRenderFns } from "./stacktrace.vue?vue&type=template&id=770dcaa5"
import script from "./stacktrace.vue?vue&type=script&lang=js"
export * from "./stacktrace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports